"use client";

import React from "react";

const TreatmentProcess: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          The All-on-6 Treatment Process
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Treatment at Smile4Me Dental Care follows a clear, step-by-step
          process. Every stage is designed to keep you informed and
          comfortable.
        </p>
        <ol className="list-decimal list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Consultation and Evaluation:</strong> We examine your oral
            health, discuss your goals, and outline your personalized treatment
            plan.
          </li>
          <li>
            <strong>X-Rays and 3D Scans:</strong> Detailed scans guide precise
            implant placement and identify any bone concerns early.
          </li>
          <li>
            <strong>Temporary Restorations:</strong> You&apos;ll receive a
            temporary set of teeth while your implants heal. You won&apos;t
            leave our office without a smile.
          </li>
          <li>
            <strong>Final Implant Placement:</strong> Your custom prosthetics
            are attached securely to the implants for a permanent,
            natural-looking result.
          </li>
        </ol>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Dr. Khaimov uses advanced 3D imaging and digital planning tools
          throughout the process. This makes implant placement more precise,
          more predictable, and more comfortable.
        </p>
      </div>
    </section>
  );
};

export default TreatmentProcess;
